import React from 'react'
import { connect } from 'react-redux'
import { 
  getReviewAssigInfo, setReviewAssigInfo, 
  removetReviewAssign, updateReviewAssignSelect //, updateReviewAssignAllowDownload 
} from './actions'
import { deleteReviewAssignPost, saveReviewAssignAllowDownloadPost } from './thunks'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import { BsFillTrashFill } from "react-icons/bs"
import './ReviewAssignTable.css'

const ReviewAssignTable = ({ 
  userInfo, groupInfo, reviewInfo, reviewAssignInfo = { reviewers:[] },
  startSetReviewAssignTableInfo, startGetReviewAssignInfo, startRemoveReviewAssign,
  startUpdateReviewAssignSelect, // startUpdateReviewAssignAllowDownload, 
  startDeleteReviewAssignPost, startSaveReviewAssignAllowDownloadPost }) => {
    
  const onReviewerSelect = (event) => {
    const userId = event.target.getAttribute('data-user');
    const selected = event.target.checked;
    // console.log('--> selected:', userId, selected);
    startUpdateReviewAssignSelect({ userId, selected });
  };
  
  const onReviewerAllowDownload = (event) => {
    const userId = event.target.getAttribute('data-user');
    const allowDownload = event.target.checked;
    // console.log('--> allowDownload:', userId, allowDownload);
    const reviewAssignData = { 
      milestoneId: reviewInfo.milestoneId, 
      groupId: reviewInfo.groupId, 
      userId: userId, 
      allowDownload: allowDownload
    };
    // console.log('--> reviewAssignData:', reviewAssignData);
    startSaveReviewAssignAllowDownloadPost(reviewAssignData);
  };
  
  const content = (
    <div>
      <Table responsive className="table-review-assign">
        <thead>
          <tr>
            <th>Reviewer</th>
            <th>Delete</th>
            <th>Send</th>
            <th>Allow to Download</th>
          </tr>
        </thead>
        <tbody>
          {reviewAssignInfo.reviewers.map((reviewer, index) => (
          <tr key={reviewer.userId}>
            <td key="user">{reviewer.userId}</td>
            <td key="delete" data-user={reviewer.userId}>
            <BsFillTrashFill  
              onClick= {(event) => { 
                console.log('delete clicked', event); 
                const userId = 
                  event.target.parentElement.getAttribute('data-user') || 
                  event.target.parentElement.parentElement.getAttribute('data-user');
                console.log('>>> userId to delete:', userId);
                // data: milestoneId, groupId, userId
                const deleteReviewData = { 
                  milestoneId: reviewInfo.milestoneId, 
                  groupId: reviewInfo.groupId, 
                  userId: userId, 
                };
                console.log('>>> deleteReviewAssign deleteReviewData:', deleteReviewData);
                startDeleteReviewAssignPost(deleteReviewData);
              }} 
            /></td>
            <td key="send">
              <Form.Check type="checkbox" data-user={reviewer.userId} 
                checked={reviewer.selected} onClick={onReviewerSelect} />
            </td>
            <td key="download">
              <Form.Check type="checkbox" data-user={reviewer.userId}
                checked={reviewer.allowDownload} onClick={onReviewerAllowDownload} />
            </td>
          </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
  return content;
}

const mapState = state => ({
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
})

const mapDispatch = dispatch => ({
  startSetReviewAssignTableInfo: (data) => dispatch(setReviewAssigInfo(data)),
  startGetReviewAssignInfo: () => dispatch(getReviewAssigInfo()),
  startRemoveReviewAssign: (userId) => dispatch(removetReviewAssign(userId)),
  startDeleteReviewAssignPost: (data) => dispatch(deleteReviewAssignPost(data)),
  startUpdateReviewAssignSelect: (data) => dispatch(updateReviewAssignSelect(data)),
  // startUpdateReviewAssignAllowDownload: (data) => dispatch(updateReviewAssignAllowDownload(data)),
  startSaveReviewAssignAllowDownloadPost: (data) => dispatch(saveReviewAssignAllowDownloadPost(data)),
})

export default connect(mapState, mapDispatch)(ReviewAssignTable);
